import { Route } from '@angular/router';
import {
    TenderContractsResolver,
    TenderDocumentsResolver,
    TenderRequestedDocumentsResolver,
    TenderSuppliersResolver,
    TenderCoverLetterResolver, TenderInvitedSupplierUsersResolver
} from '../../../resolvers';
import { CreateTenderReviewComponent } from '../../../../pages';
import { TenderStepGuard } from '../../../guards';

export const createTenderReviewRoute: Route = {
    path: 'review',
    component: CreateTenderReviewComponent,
    canActivate: [TenderStepGuard],
    resolve: {
        coverLetter: TenderCoverLetterResolver,
        documents: TenderDocumentsResolver,
        requestedDocuments: TenderRequestedDocumentsResolver,
        tenderInvitedSupplierUsers: TenderInvitedSupplierUsersResolver
    }
};
